const Uuid = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
/**
 * Returns true if the value is a uuid
 * @specification
 * @source ajv-formats
 */
export function IsUuid(value) {
    return Uuid.test(value);
}
